<style>
	:global(body) {
		margin: 0px;
		padding: 0px;
		font-family: 'IBM Plex Sans', sans-serif;
		background-color: white;
	}

	:global(button) {
		border: none;
		border-radius: 15px;
		cursor: pointer;
		padding: 8px;
		padding-left: 12px;
		padding-right: 12px;
	}

	:global(h1) {
		line-height: 1.2em;
	}

	:global(button:hover) {
		background-color: rgb(70, 70, 70);
		color: white;
	}

	:global(input, textarea) {
		border-radius: 15px;
		padding: 8px;
	}

	#main-container {
		position: fixed;
		left: 0;
		width: 100%;
		max-width: 100%;
		height: 100%;
		max-height: 100%;
		display: flex;
		flex-direction: column;
	}

	#container {
		flex: 1;
		display: flex;

		width: 100%;
		max-width: 100%;
		height: 100%;
		max-height: calc(100% - 65px);
		z-index: 1;
	}

	

	@media (max-width:972px) {
		#container {
			flex-direction: column;
		}

		:global(button:hover) {
			color: #333;
			background-color: #f4f4f4;
		}
	}
</style>
<script>
	import {onMount} from 'svelte'
	import {push, location} from '../pt-router/Router.svelte'
	import {gapi} from 'gapi-script';

	import Tools from './Tools.svelte';

	import * as Common from '../Common.js'

	import NavBar from '../NavBar.svelte';
	import MapView from '../MapView.svelte';
	import SideStage from '../SideStage.svelte';
	import Notifications from '../Notifications.svelte';

	export let params;

	let page = 'consumer'
	let sideStage = true
	let items = []
	let hilightedItems = null
	let bounds = false;
	let showExtendedBar = false;
	let enableSelection = false;
	let showMapOnMobile = false;
	let forcedRefreshPending = false
	
	onMount(async () => {
		window.onresize = () => {
			showExtendedBar = !Common.isMobile()
		}
		onMount(async () => {
			gapi.signin2.render('hiddensignin', {
			});
		})
	})

	$: refreshed = params && Common.updateLoggedInUser(analyzeUrl)
	function analyzeUrl() {
		hilightedItems = null
		page = 'consumer'
		document.title = "Plan Together"
		enableSelection = false;
		showExtendedBar = !Common.isMobile()

		// don't show spinner if fast load
		if(params.page && Common.isMobile()) {
			let nextPage = params.page
			window.setTimeout(() => {
				console.log(sideStage.page + ":" + nextPage)
				if(sideStage.page===nextPage) {
					return
				}
				sideStage = {
					page: "spinner"
				}
			}, 100)
		}
		if(!Common.isMobile()) {
			sideStage = {
				page: "spinner"
			}
		}
			
		let pageUrl = '/'
		if(params.page) {
			pageUrl += params.page + '/'
		}
		if(params.id) {
			pageUrl += params.id + '/'
		}

		if(params.page === 'item') {
			hilightedItems = [Number(params.id)]
			Common.getData('item/' + params.id)
			.then(data => {
				if(!data) {
					sideStage = { page: "none" }
					return
				}

				showMapOnMobile = true
				document.title += " - Item - " + data.item_title
				bounds = {
					lat : data.item_latitude,
					lng : data.item_longitude,
					zoom : 16.0
				}
				sideStage = {
					page: params.page,
					item: data
				}
			})
		} else if(params.page === 'user') {
			forcedRefreshPending = true
			goToCurrentLocationIfNoBounds()
			Common.getData('user/' + params.id)
			.then(data => {
				if(!data) {
					sideStage = { page: "none" }
					return
				}

				showMapOnMobile = false;
				document.title += " - User - " + data.user_name
				sideStage = {
					page: params.page,
					user: data
				}
			})
		} else if(params.page == 'account') {
			showMapOnMobile = false;
			goToCurrentLocationIfNoBounds()
			document.title += " - Account Management"
			sideStage = {
				page: params.page
			}
		
		} else if (params.page === 'add-item') {
			hilightedItems = []
			showMapOnMobile = true
			if(Common.currentUserValue && (Common.currentUserValue.user_area_id != 0) && !bounds) {
				Common.getData('area/'+Common.currentUserValue.user_area_id)
				.then(data => {
					bounds = {
						lat : (data.first_latitude + data.second_latitude) / 2,
						lng : (data.first_longitude + data.second_longitude) /2,
						zoom : 12
					}
				})
			} else {
				goToCurrentLocationIfNoBounds()
			}
			enableSelection = true;
			document.title += " - Add Item"
			sideStage = {
				page: params.page,
				type : params.id
			}
		} else if(params.page === 'login') {
			showMapOnMobile = false;
			goToCurrentLocationIfNoBounds()
			document.title += " - Login"
			sideStage = {
				page: params.page
			}
		} else if(params.page === 'comment') {
			Common.getData('comment/' + params.id)
			.then(data => {
				if(!data) {
					sideStage = { page: "none" }
					return
				}

				hilightedItems = [Number(data.item_id)]
				showMapOnMobile = true
				document.title += " - Comment"
				bounds = {
					lat : data.item_latitude,
					lng : data.item_longitude,
					zoom : 16.0
				}
				sideStage = {
					page: params.page,
					comment: data
				}
			})
		} else if(params.page === 'inbox') {
			showMapOnMobile = false;
			goToCurrentLocationIfNoBounds()
			document.title += " - Inbox"
			sideStage = {
				page: params.page,
			}
		} else if(params.page === 'area') {
			forcedRefreshPending = true
			Common.getData('area/' + params.id)
			.then(data => {
				if(!data) {
					sideStage = { page: "none" }
					return
				}

				showMapOnMobile = true
				document.title += " - Area - " + data.name
				bounds = {
					lat : (data.first_latitude + data.second_latitude) / 2,
					lng : (data.first_longitude + data.second_longitude) /2,
					zoom : 12
				}
				sideStage = {
					page: params.page,
					area : data
				}

				setTimeout(() => {
					forcedRefreshPending = true
				},500)
			})
		} else if(params.page === 'policies') {
			showMapOnMobile = false;
			goToCurrentLocationIfNoBounds()
			document.title += " - Policies"
			sideStage = {
				page: 'policies'
			}
		} else if(params.page === 'contact') {
			showMapOnMobile = false;
			goToCurrentLocationIfNoBounds()
			document.title += " - Contact"
			sideStage = {
				page: 'contact'
			}
		} else if (params.page === 'forgot-password') {
			showMapOnMobile = false;
			goToCurrentLocationIfNoBounds()
			document.title += " - Forgot Password"
			sideStage = {
				page: 'forgot-password'
			}
		} else if(params.page === 'reset-password') {
			showMapOnMobile = false;
			goToCurrentLocationIfNoBounds()
			document.title += " - Reset Password"
			sideStage = {
				page: 'reset-password',
				code: params.id
			}
		} else if(params.page === 'areas') {
			showMapOnMobile = false;
			goToCurrentLocationIfNoBounds()
			document.title += " - All Areas"
			sideStage = {
				page: 'areas'
			} 
		} else if(params.page === 'about') {
			showMapOnMobile = false;
			goToCurrentLocationIfNoBounds()
			document.title += " - About Plan Together"
			sideStage = {
				page: 'about'
			}
		} else if(params.page === 'tools') {
			showMapOnMobile = false;
			page = 'tools'
		}  else if(params.page === 'areaadmin') {
			showMapOnMobile = false;
			Common.getData('area/' + params.id)
			.then(data => {
				document.title += " - Area Profile - " + data.name
				bounds = {
					lat : (data.first_latitude + data.second_latitude) / 2,
					lng : (data.first_longitude + data.second_longitude) /2,
					zoom : 12
				}
				sideStage = {
					page: params.page,
					area : data
				}
			})
		} else if(params.page === 'startdemo') {
			if("API_URL" === "https://demoapi.plantogether.city") {
				Common.postData('create-demo-user')
				.then(r => {
					if(!r.ok) {
						alert("Problem creating demo user")
						return
					}

					Common.updateLoggedInUser(() => {
						push('/tools/incoming')
						Common.CreateNotification({body: `
							Welcome to the Live Demo of Plan Together Municipal Tools!<br><br>
							It allows you to explore the platform in a sandbox separate from the main site.<br><br>
							Try adding some Official Items!<br><br>
							<a href="https://plantogether.city/tools-landing">Click Here to Learn More</a>`}, 1000, 1200000)
					})
				})
			}	
		} else if(params.page === 'tag') {
			if(!("area_id" in params.query)) {
				goToCurrentLocationIfNoBounds()
				setTimeout(() => {
					forcedRefreshPending = true	
				},0)
			}

			showMapOnMobile = false;
			document.title = "#" + params.id + " on Plan Together"
			sideStage = {
				page: params.page,
				tag : params.id,
				area_id : ("area_id" in params.query) ? Number(params.query["area_id"]) : null
			}

			if("area_id" in params.query) {
				Common.getData('area/' + params.query["area_id"])
				.then(data => {
					if(!data) {
						return
					}
					bounds = {
						lat : (data.first_latitude + data.second_latitude) / 2,
						lng : (data.first_longitude + data.second_longitude) /2,
						zoom : 12
					}

					document.title = "#" + params.id + " in " + data.name + " on Plan Together"
					
					setTimeout(() => {
						forcedRefreshPending = true	
					},0)
				})
			}
		} else if(params.page === 'unsubscribe') {
			sideStage = {
				page: 'unsubscribe'
			}
		} else {
			showMapOnMobile = true
			bounds = false
			goToCurrentLocationIfNoBounds()
			sideStage = {
				page: 'welcome'
			}
		}
	}

	function openSideBar(newStage) {
		sideStage = newStage
	}

	function setNewItemLocation(location) {
		if(params.page != 'add-item')
			return;
		sideStage.itemLocation = location
	}

	function requestNewItems(req) {
		Common.postData('items', req)
		.then(r => {
			if(!r.ok) {
				alert("Problem getting latest items. Please refresh the page")
			} else {
				items = r.data
			}
		});

		req.exclude = {}
		if(params.page == 'tag') {
			console.log("Page is tag!")
			let tagReq = {
				geoitemsrequest: req,
				tag : params.id
			}

			Common.postData('items-tag', tagReq)
			.then(r => {
				if(!r.ok) {
					alert("Problem getting latest hilighted items. Please refresh the page")
				} else {
					hilightedItems = r.data
				}
			});
		} else if(params.page === 'user') {
			let tagReq = {
				geoitemsrequest: req,
				user_id : Number(params.id)
			}
			Common.postData('items-user', tagReq)
			.then(r => {
				if(!r.ok) {
					alert("Problem getting latest hilighted items. Please refresh the page")
				} else {
					hilightedItems = r.data
				}
			});
		} else if(params.page === 'area') {
			let tagReq = {
				geoitemsrequest: req,
				area_id : Number(params.id)
			}
			Common.postData('items-area', tagReq)
			.then(r => {
				if(!r.ok) {
					alert("Problem getting latest hilighted items. Please refresh the page")
				} else {
					hilightedItems = r.data
				}
			});
		}
	}

	function goToCurrentLocationIfNoBounds() {
		if(!bounds) {
			if(!navigator.geolocation) {
				bounds = {
					lng : -80.52252,
					lat : 43.46351,
					zoom : 13.0
				}
				return
			}

			navigator.geolocation.getCurrentPosition(p => {
				bounds = {
						lng : p.coords.longitude,
						lat : p.coords.latitude,
						zoom : 13.0
					}
			}, e => {
				bounds = {
					lng : -80.52252,
					lat : 43.46351,
					zoom : 13.0
				}
			})
		}
	}
</script>

<link rel="stylesheet" type="text/css" href="https://unpkg.com/pell/dist/pell.min.css">
<link href="https://fonts.googleapis.com/css?family=Roboto&display=swap" rel="stylesheet"> 


	<div id="main-container">
		<NavBar {openSideBar} bind:showExtendedBar></NavBar>
		{#if page === 'tools'}
			<Tools {params}></Tools>
		{:else}
			<div id="container">
				{#if !Common.isMobile() || showMapOnMobile}
					<MapView bind:items bind:hilightedItems bind:forcedRefreshPending newItemType={sideStage.type} {requestNewItems} {setNewItemLocation} {bounds} {enableSelection}></MapView>
				{/if}
				<SideStage bind:items {showMapOnMobile} bind:stage={sideStage}></SideStage>
			</div>
		{/if}
	</div>


<div style="visibility:hidden" id="hiddensignin"></div>
<Notifications></Notifications>